import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';

export const AuthPublicProvidersRequest = object('AuthPublicProvidersRequest', {
  tenant: string(),
  realm: string(),
});
